// extracted by mini-css-extract-plugin
module.exports = {"input":"inputs_input__i7oa0"};